<template>
  <main class="ead-area">
    <header class="ead-area__header">
      <div class="ead-area__brand">
        <span class="ead-area__mark"><b-icon icon="school-outline" /></span>
        <div><small>METAVIRTUE · DESENVOLVIMENTO</small><strong>Treinamentos e cursos</strong></div>
      </div>
      <nav class="ead-area__nav" aria-label="Área de cursos">
        <router-link :to="{ name: 'rh-dashboard' }" exact>Menu Principal</router-link>
        <router-link :to="{ name: 'ead-meus-cursos' }" :class="{ 'is-active': secaoAtiva === 'meus' }">Meus Cursos</router-link>
        <router-link v-if="podeGerir" :to="{ name: 'ead-cursos' }" :class="{ 'is-active': secaoAtiva === 'cadastros' }">Cadastros de Cursos</router-link>
        <router-link v-if="podeGerir" :to="{ name: 'ead-liberacoes' }" :class="{ 'is-active': secaoAtiva === 'acessos' }">Acesso aos Cursos</router-link>
        <router-link v-if="podeGerir" :to="{ name: 'ead-relatorio' }" :class="{ 'is-active': secaoAtiva === 'relatorios' }">Relatórios</router-link>
      </nav>
    </header>
    <div class="ead-area__content"><router-view /></div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EadArea',
  computed: {
    ...mapGetters(['isInRole']),
    podeGerir() {
      return this.isInRole('rh-diretoria')
    },
    secaoAtiva() {
      const nomeRota = this.$route.name
      if (['ead-meus-cursos', 'ead-curso-player', 'ead-avaliacao'].includes(nomeRota)) return 'meus'
      if (['ead-cursos', 'ead-curso-cadastro', 'ead-curso-conteudo', 'ead-avaliacao-conteudo'].includes(nomeRota)) return 'cadastros'
      if (nomeRota === 'ead-liberacoes') return 'acessos'
      if (['ead-relatorio', 'ead-dashboard-admin', 'ead-progresso-detalhe'].includes(nomeRota)) return 'relatorios'
      return null
    },
  },
}
</script>

<style scoped>
.ead-area { min-height: 100vh; background: #f5f7fb; color: #21324b; }
.ead-area__header { background: #fff; border-bottom: 1px solid #e3e9f2; padding: 18px clamp(20px, 4vw, 56px) 0; box-shadow: 0 2px 16px rgba(22, 40, 71, .04); }
.ead-area__brand { display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
.ead-area__mark { display: grid; place-items: center; width: 42px; height: 42px; border-radius: 12px; color: #fff; background: #174b7b; }
.ead-area__brand small, .ead-area__brand strong { display: block; }
.ead-area__brand small { font-size: 10px; letter-spacing: .13em; font-weight: 700; color: #718096; }
.ead-area__brand strong { font-size: 18px; color: #183b5c; }
.ead-area__nav { display: flex; gap: 6px; overflow-x: auto; white-space: nowrap; }
.ead-area__nav a { display: inline-flex; align-items: center; padding: 11px 14px 13px; border-bottom: 3px solid transparent; font-size: 13px; font-weight: 650; color: #52637a; }
.ead-area__nav a:hover, .ead-area__nav a.is-active { color: #145d86; border-bottom-color: #27a19a; }
.ead-area__nav a.is-active { background: #eef8f7; font-weight: 700; }
.ead-area__content { max-width: 1440px; margin: 0 auto; padding: 28px clamp(16px, 4vw, 56px) 48px; }
@media (max-width: 760px) { .ead-area__header { padding: 14px 12px 0; } .ead-area__nav a { padding: 10px; } .ead-area__content { padding: 18px 12px 36px; } }
</style>
